export class InternalAuditScopeItemDTO {
  entityType!: number;

  entityId!: number;

  code?: string;

  name?: string;

  plannedOn?: string;
}

export class InternalAuditScopeRelationDTO {
  fromEntityType!: number;

  fromEntityId!: number;

  toEntityType!: number;

  toEntityId!: number;
}

export class InternalAuditScopeSuggestionDTO {
  entityType!: number;

  entityId!: number;

  code?: string;

  name?: string;

  reason?: string;
}

export class InternalAuditScopeSuggestionsRequestDTO {
  instructions?: string;

  isoNormIds: number[] = [];
}

export class InternalAuditScopeCandidateDTO {
  entityType!: number;

  entityId!: number;

  code?: string;

  name?: string;

  isoNormIds!: number[];

  normIds!: number[];

  score!: number;

  lastAuditedOn?: string;

  riskScore!: number;

  riskCount!: number;
}

export default class InternalAuditScopeDTO {
  internalAuditId!: number;

  items!: InternalAuditScopeItemDTO[];

  relations!: InternalAuditScopeRelationDTO[];
}

// The scope of one audit without its relations: what a list needs to search on. Audits with an
// empty scope are left out of the response.
export class InternalAuditScopeIndexDTO {
  internalAuditId!: number;

  items!: InternalAuditScopeItemDTO[];
}

// The whole scope in one payload, grouped per entity family. All six lists are always sent:
// an empty list is what clears a family (requirements go into controlIds - same id space).
export class InternalAuditScopeIdsDTO {
  controlIds: number[] = [];

  processIds: number[] = [];

  riskIds: number[] = [];

  assetIds: number[] = [];

  processingActivityIds: number[] = [];

  objectiveIds: number[] = [];

  linkIds: number[] = [];
}
